import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { db } from 'firebase/index'
import { PushMessageType } from 'types/pushMessage'
import { fetchPushMessagesAction } from 'reducks/pushMessage/actions'

const fetchPushMessages = () => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    // 1週間以上前の古いデータを消す
    const startDate = new Date()
    startDate.setDate(startDate.getDate() - 7)
    const query = await db
      .collection('staff_push_messages')
      .where('staff_id', '==', getState().auth.uid)
      .where('store_id', '==', getState().auth.store_ref.id)
      .orderBy('created_at', 'desc')
      .startAt(startDate)
      .get()
    query.docs.forEach(async (doc) => {
      await doc.ref.delete()
    })

    //プッシュ通知のメッセージを全て取得
    const messages = await db
      .collection('staff_push_messages')
      .where('staff_id', '==', getState().auth.uid)
      .where('store_id', '==', getState().auth.store_ref.id)
      .orderBy('created_at', 'desc')
      .get()
      .then((snapshots) => {
        const _messages: PushMessageType[] = []
        snapshots.forEach((snapshot) => {
          const data = snapshot.data() as PushMessageType
          _messages.push(data)
        })
        return _messages
      })
      .catch((error: unknown) => {
        console.error(error)
        return []
      })
    dispatch(fetchPushMessagesAction(messages))
  }
}

export default fetchPushMessages
